import { style } from "typestyle";

// 1. Step in common:

export const workflowStepCN = style({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  position: "relative",
  alignItems: "flex-start",
  borderLeft: "4px solid rgba(0, 0, 0, 0.01)",
  background: "#FFFFFF",
  $nest: {
    "&:first-child": {
      borderRadius: "2px 2px 0px 0px",
    },
    "&:last-child": {
      borderRadius: "0px 0px 2px 2px",
    },
  },
});

export const workflowStepContentCN = style({
  padding: "24px 20px",
  paddingBottom: "32px",
  borderTop: "1px solid #E6E7EC",
  width: "100%",
});

export const workflowStepContentNoBorderCN = style({
  borderTop: "none",
});

export const workflowStepIdLabelCN = style({
  position: "absolute",
  top: "24px",
  left: "-44px",
  width: "24px",
  minWidth: "24px",
  height: "24px",
  textAlign: "center",
  verticalAlign: "middle",
  fontWeight: "lighter",
  fontSize: "24px",
  lineHeight: "32px",
  margin: "5px 0",
  $nest: {
    "& *": {
      maxWidth: "24px",
      maxHeight: "24px",
    },
  },
});

export const workflowStepContentTitleCN = style({
  color: "rgba(0,0,0,0.87)",
  fontSize: "24px",
  lineHeight: "32px",
  margin: "4px 0",
});

export const workflowStepContentDescriptionCN = style({
  color: "rgba(0,0,0,0.87)",
  fontSize: "14px",
  lineHeight: "20px",
});

export const workflowStepActionsInputsCN = style({
  $nest: {
    "&>*": {
      marginTop: "32px",
    },
  },
});

export const workflowStepBottomAlertCN = style({
  width: "100%",
  marginTop: "8px",
});

// 2. Step types:

// 2.1. running

export const workflowStepRunningCN = style({
  borderLeft: "4px solid #089DF4",
  background: "#FFFFFF",
  boxShadow:
    "0 0px 20px 0 rgba(0, 0, 0, 0.15), 0 18px 38px 0 rgba(0, 0, 0, 0.3)",
  zIndex: 1,
});

export const workflowStepRunningIdLabelCN = style({
  color: "#089DF4",
});

// 2.2. failed

export const workflowStepFailedCN = style({
  borderLeft: "4px solid #D0021B",
  boxShadow:
    "0 0px 20px 0 rgba(0, 0, 0, 0.15), 0 18px 38px 0 rgba(0, 0, 0, 0.3)",
  zIndex: 1,
});

export const workflowStepFailedIdLabelCN = style({
  color: "#D0021B",
});

export const workflowStepFailedAlertContainerCN = style({
  width: "100%",
  borderRadius: 12,
  margin: "0 0 24px",
});

// 2.3. successful

export const workflowStepSuccessfulCN = style({
  borderLeft: "4px solid rgba(0, 0, 0, 0.01)",
  background: "#F7F8FA",
});

// 2.4. waiting

export const workflowStepWaitingCN = style({
  borderLeft: "4px solid #000",
  background: "#F7F8FA",
});

// 2.5. service

export const workflowStepServiceCN = style({
  borderLeft: "4px solid #E6E7EC",
  background: "#F7F8FA",
});

export const workflowStepServiceIdLabelCN = style({
  color: "#9E9E9E",
});

export const workflowStepServiceContentTitleCN = style({
  color: "#9E9E9E",
});

export const workflowStepServiceContentDescriptionCN =
  workflowStepServiceContentTitleCN;

export const workflowStepServiceFutureAlertCN = style({
  color: "#F89900",
  fontSize: "14px",
  lineHeight: "20px",
  marginTop: "12px",
});

export const workflowStepServiceBottomAlertCN = style({
  width: "100%",
  marginTop: "-8px",
});

// 4. Alert error

export const alertErrorCN = style({
  display: "flex",
  flexDirection: "row",
  padding: "0 5px",
  background: "#FFDFDF",
  overflow: "hidden",
});

export const alertErrorIconBlockCN = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "68px",
  minWidth: "68px",
});

export const alertErrorTextBlockCN = style({
  display: "flex",
  flexDirection: "column",
  padding: "16px 0",
  color: "#000",
});

export const alertErrorTextBlockHeaderCN = style({
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "24px",
});

export const alertErrorTextBlockMessageCN = style({
  overflowWrap: "anywhere",
  overflowY: "auto",
  maxHeight: 300,
  fontSize: "16px",
  lineHeight: "24px",
  marginTop: "4px",
});
